import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=027f0ade&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=027f0ade&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f0ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027f0ade')) {
      api.createRecord('027f0ade', component.options)
    } else {
      api.reload('027f0ade', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=027f0ade&scoped=true", function () {
      api.rerender('027f0ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/documentConfiguration/Detail.vue"
export default component.exports